import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import {
  Landing,
  Home,
  Profile,
  LearnStrategy,
  Rules,
  Practice,
  PracticeGameSelect,
  About,
  Main,
  PlayGame,
  Register,
  ForgotPassword,
  ResetPassword,
  Play,
  ProtectedRoute,
  GameSettings,
  Settings,
  GameHistory,
  Standings,
} from "./pages";
import practiceGames from "./practiceGames";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Main />}>
          <Route index element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route
            path="/profile"
            element={
              <ProtectedRoute>
                <Profile />
              </ProtectedRoute>
            }
          />
          <Route path="/rules" element={<Rules />} />
          <Route path="/strategy" element={<LearnStrategy />} />

          <Route path="/practice" element={<Practice />}>
            <Route index element={<PracticeGameSelect />} />
            {practiceGames.map((game) => (
              <Route
                key={game.id}
                path={game.path}
                element={<game.component />}
              />
            ))}
          </Route>
          <Route path="/standings" element={<Standings />} />
          <Route path="/play" element={<Play />}>
            <Route index element={<GameSettings />} />
            <Route path="play-game" element={<PlayGame />} />
          </Route>
          <Route
            path="/settings"
            element={
              <ProtectedRoute>
                <Settings />
              </ProtectedRoute>
            }
          />
          <Route
            path="/settings/history"
            element={
              <ProtectedRoute>
                <GameHistory />
              </ProtectedRoute>
            }
          />
        </Route>

        <Route path="/landing" element={<Landing />} />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </Router>
  );
}

export default App;
